/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import { unitBase, enterpriseCSS } from '../variables';

export const StatusTrackingBar = () => ({
    StatusTrackingBar: {
        // ROSS status images
        '& .ROSS-status-img': {
            height: '35px',
        },
        // Status tracking bar
        '& .statusTrackingBar': {
            display: 'table',
            whiteSpace: 'nowrap',
            width: `${unitBase * 75}px`, // 300px
            margin: '0 auto',
            textAlign: 'center',
            height: '30px',
            position: 'relative',

            '&[class*="step-"]': {
                '& > div': {
                    display: 'table-cell',
                    position: 'relative',
                },
                '& .step': {
                    width: '33%',

                    '&:after': {
                        height: unitBase * 2,
                        content: '""',
                        background: enterpriseCSS.palette.gray2,
                        width: `calc(100% - ${unitBase}px)`,
                        position: 'absolute',
                        left: 2,
                        bottom: unitBase,
                    },

                    '&:first-of-type::after': {
                        borderRadius: '12px 0 0 12px',
                    },
                    '&:nth-of-type(3)::after': {
                        borderRadius: '0 12px 12px 0',
                    },

                    '& .h2': {
                        color: enterpriseCSS.palette.gray1,
                        fontWeight: 'normal',
                    },
                },
                '&.step-0': {
                    '& .step': {
                        '&:after': {
                            background: enterpriseCSS.palette.error,
                        },
                        '& .h2': {
                            color: enterpriseCSS.palette.error,
                            fontWeight: 'bold',
                        },
                    },
                },
                '&.step-1': {
                    '& .step:nth-of-type(1)': {
                        '&:after': {
                            background: enterpriseCSS.palette.green,
                        },
                        '& .h2': {
                            color: enterpriseCSS.palette.green,
                            fontWeight: 'bold',
                        },
                    },
                },
                '&.step-2': {
                    '& .step:nth-of-type(2)': {
                        '&:after': {
                            background: enterpriseCSS.palette.green,
                        },
                        '& .h2': {
                            color: enterpriseCSS.palette.green,
                            fontWeight: 'bold',
                        },
                    },
                },
                '&.step-3': {
                    // width: `${unitBase * 80}px`, // 320px

                    '& .step:nth-of-type(3)': {
                        '&:after': {
                            background: enterpriseCSS.palette.green,
                        },
                        '& .h2': {
                            color: enterpriseCSS.palette.green,
                            fontWeight: 'bold',
                        },
                    },
                },
            },

            '& svg': {
                height: '38px',
                width: '20px',
                verticalAlign: 'middle',
                position: 'absolute',
                bottom: '-4px',
                right: 0,
            },

            '& .arrivedGift': {
                minWidth: '20px',
                '&:after': {
                    content: 'none',
                },
            },
        },
    },
});
